import { render } from "./DictationWord.vue?vue&type=template&id=18453114&scoped=true"
const script = {}

import "./DictationWord.vue?vue&type=style&index=0&id=18453114&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18453114"]])

export default __exports__